/**
 * Chức năng -> quyền (codename Django, BE: lms_core/permission_catalog.py).
 * Đây là chỗ duy nhất khai báo quyền cho FE: đổi quyền của một chức năng chỉ sửa ở đây.
 * Kiểm tra bằng usePermission().can(...) hoặc <PermissionGuard permission={...}>.
 */
export const PERM = {
    student: {
        dashboard: 'view_dashboard',
        dashboardExport: 'export_dashboard',
        calendar: 'view_lmszoommeeting',
        joinMeeting: 'join_lmszoommeeting',
        practice: 'view_submodules', // Bài tập và Sách dùng chung quyền
        book: 'view_submodules',
        exam: 'view_examprocessactivity',
        report: 'view_coursewareactivity',
    },
    // Sidebar giáo viên (components/MenuTeacher)
    teacher: {
        dashboard: 'view_dashboard',
        class: 'view_classes',
        resetStudentPassword: 'reset_password_account',
        calendar: 'view_lmszoommeeting',
        calendarCreate: 'add_lmszoommeeting',
        calendarUpdate: 'change_lmszoommeeting',
        calendarDelete: 'delete_lmszoommeeting',
        joinMeeting: 'join_lmszoommeeting',
        // Bài tập trong buổi học trực tuyến
        meetingExerciseCreate: 'add_lmszoomexercise',
        meetingExerciseAssign: 'assign_lmszoomexercise',
        meetingExerciseDelete: 'delete_lmszoomexercise',
        meetingExerciseResult: 'view_lmszoomexercise',
        meetingExerciseExport: 'export_lmszoomexercise',
        distribution: 'view_submodules', // Giao bài & Đánh giá: danh sách bài
        assignPractice: 'add_submoduleclasspractice',
        unassignPractice: 'delete_submoduleclasspractice',
        assignExam: 'add_examprocessactivity',
        extendExam: 'add_examextends', // Giao / gia hạn bài thi cho từng học sinh
        modules: 'view_modules', // Tài liệu giảng dạy
        reportPractice: 'view_coursewareactivity',
        reportPracticeExport: 'export_coursewareactivity',
        reportExam: 'view_examprocessactivity',
        reportExamExport: 'export_examprocessactivity',
        dashboardExport: 'export_coursewareactivity', // Xuất kết quả làm bài ở Tổng quan
    },
    // Màn quản trị (Tài khoản, Lớp học)
    admin: {
        accountImport: 'import_account',
        accountExport: 'export_account',
        classImport: 'import_classes',
        schoolYear: 'view_schoolyear',
        schoolYearCreate: 'add_schoolyear',
        schoolYearUpdate: 'change_schoolyear',
        schoolYearSetCurrent: 'set_current_schoolyear',
        taskHistory: 'view_taskhistory',
        taskRetry: 'change_taskhistory',
        taskCancel: 'cancel_taskhistory',
        roleMatrixView: 'view_rolepermission',
        roleCreate: 'add_roles',
        roleUpdate: 'change_roles',
        roleDelete: 'delete_roles',
        roleMatrixEdit: 'change_rolepermission',
    },
} as const;
